<div class="px-5 py-4 w-full">
  <p><b>Downlink</b>: {{ connection?.downlink }}</p>
  <p><b>Effective type</b>: {{ connection?.effectiveType }}</p>
  <p><b>Onchange</b>: {{ connection?.onchange }}</p>
  <p><b>Rtt</b>: {{ connection?.rtt }}</p>
  <p><b>Save data</b>: {{ connection?.saveData }}</p>
</div>
